import { PopoverHint } from '@newo/ui-kit';
// icons
import { ChevronRight, ChevronDown, MessageCircleQuestion } from 'lucide-react';

interface SummaryDividerProps {
    hint: React.ReactNode;
}

const SummaryDivider = ({ hint }: SummaryDividerProps) => {
    return (
        <div className="h-11 w-11 relative rounded-full bg-white text-gray-5 flex text-xl items-center justify-center self-center justify-self-center print:hidden">
            <PopoverHint
                className="absolute! -top-1 -right-1 bg-white rounded-full self-start"
                hint={hint}
                trigger={<MessageCircleQuestion />}
            />
            <ChevronRight className="hidden xl:block" />
            <ChevronDown className="xl:hidden" />
        </div>
    );
};

export default SummaryDivider;
